import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=71fe75c4&"
import script from "./folderDetails.vue?vue&type=script&lang=js&"
export * from "./folderDetails.vue?vue&type=script&lang=js&"
import style0 from "./folderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports